const Domains = {
  tmn_tag: 'tmntag.js', ramp: 'ramp'
};

export default Domains;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/StaticData/Domains.tsx